
<div mat-dialog-title>
  Create an External Account
  <button class="close" mat-button title="Cancel" (click)="close()">
    <i class="material-icons clear">clear</i>
  </button>
</div>
<mat-dialog-content>
  @if (isAccActive && acctExists && !isRestoreExisted) {
    <mat-card class="error block">
      <mat-card-title class="error">Account number is already in use</mat-card-title>
      <mat-card-subtitle>Please enter a different account number.</mat-card-subtitle>
    </mat-card>
  }
  @if (isRestoreExisted) {
    <mat-card class="warn block">
      <mat-card-title class="warn">This is the account number of a deleted external account.</mat-card-title>
      <mat-card-subtitle class="ext-account-restore-existed-sub">
        <div style="margin-bottom: 3px;">You can restore the deleted external account. If you do this...</div>
        <div>If you do not want to restore the deleted external account, enter a new account number and continue.</div>
      </mat-card-subtitle>
    </mat-card>
  }
  @if (!isRestoreExisted) {
    <div class="intro-txt">
      You can add or import accounts that are not held at Charles Schwab & Company, Inc. to an
      iRebal portfolio. When you do, these accounts and their holdings will be
      considered in a rebalance, but trades will <em>not</em> be identified for
      these accounts—they will be treated as frozen.
    </div>
  }
  @if (viewLoaded && !isRestoreExisted) {
    <div class="external-accounts-form">
      <div class="col">
        <label>Account Number</label>
        <irb-validation-text-box
          [(value)]="externalAccount.accountNumber"
          regExp="[a-zA-Z0-9\s\-\,]{1,20}"
          max="20"
          invalidMessage="Invalid account number"
          placeholder="Enter Account number"
          width="165px"
          autofocus="true"
        ></irb-validation-text-box>
      </div>
      <div class="col">
        <label>Account Name</label>
        <irb-validation-text-box
          [(value)]="externalAccount.accountName"
          max="50"
          invalidMessage="The value entered is not valid."
          width="260px"
          placeholder="Enter Account name"
        ></irb-validation-text-box>
      </div>
      <div class="col">
        <label>Taxability</label>
        <irb-dropdown-filter
          #irbTaxabilityDropdown
          (search)="getTaxabilityItems()"
          size="10"
          hoverPanelWidth="135"
          (selection)="onTaxabilityChange($event)"
          [(value)]="accountLocationType"
        ></irb-dropdown-filter>
      </div>
      <div class="col">
        <label>Select a portfolio</label>
        <irb-dropdown-filter
          #irbAccountDropdown
          (search)="setAccountNameDropDownValues($event)"
          size="30"
          hoverPanelWidth="275"
          (selection)="onAccountChange($event)"
          [(value)]="portfolioId"
        ></irb-dropdown-filter>
      </div>
      <div class="col">
        <label>Select a master</label>
        <irb-dropdown-filter
          #irbAdvisorDropdown
          (search)="setMasterItems($event)"
          size="8"
          hoverPanelWidth="122"
          (selection)="onMasterChange($event)"
          [(value)]="master"
        ></irb-dropdown-filter>
      </div>
    </div>
  }
  @if (viewLoaded && isRestoreExisted) {
    <div class="external-accounts-form">
      <div class="radio-group" data-allocation-chart-group-by-radio-group>
        <div style="margin-bottom: 5px;">
          <p-radioButton [value]="true"
            [(ngModel)]="restoreOrNewRadio"
          inputId="item1"></p-radioButton>
          <label for="item1">{{'Restore deleted external account: ' + restoreAccount}}</label>
        </div>
        <div>
          <p-radioButton [value]="false" style="margin-right: 15px;"
            [(ngModel)]="restoreOrNewRadio"
          inputId="item2"></p-radioButton>
          <label for="item2">New external account number:</label>
          <irb-validation-text-box
            [(value)]="externalAccount.accountNumber"
            regExp="[a-zA-Z0-9\s\-\,]{1,20}"
            max="20"
            invalidMessage="Invalid account number"
            placeholder="Enter Account number"
            width="165px"
          ></irb-validation-text-box>
        </div>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <div>
    <button class="btn-medium-secondary" (click)="close()">Cancel</button>
    @if (viewLoaded && !isRestoreExisted) {
      <button class="btn-medium-primary"
      (click)="createExternalAccount()" [disabled]="!isValidSelections()" >Create Account</button>
    }
    @if (viewLoaded && isRestoreExisted) {
      <button class="btn-medium-primary"
      (click)="createOrRestoreExternalAccount()" [disabled]="!isValidSelectionsAfterRestore()" >Create Account</button>
    }
  </div>
</mat-dialog-actions>
